import * as React from "react"

import {MetricSelect} from "@components";
import {PriceEvolutionChartMetric} from "../../../@signals";


export default function ChartMetric({ onChange }) {
	return <MetricSelect
		fullWidth={false}
		sx={{ minWidth: 200 }}
		value={PriceEvolutionChartMetric.value}
		onChange={e => onChange(e.target.value)}
	/>
}